import BsPopover from "./BsPopover";

export default Vue => {
    Vue.component(BsPopover.name, BsPopover);
};
